<template>
  <div
    class="flex flex-1 flex-col items-center justify-center text-base text-muted-foreground"
  >
    <p class="m-0 max-w-md">
      {{ $t('assetBrowser.upgradeFeatureDescription') }}
    </p>
  </div>
</template>
